import React from "react";
import { styled, alpha, Switch } from "@mui/material";

const BlackWhiteSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#000",
        "&:hover": {
            backgroundColor: alpha("#000", theme.palette.action.hoverOpacity),
        },
    },
    "& .MuiSwitch-switchBase": {
        color: "#ccc",
        "&:hover": {
            backgroundColor: alpha("#000", theme.palette.action.hoverOpacity),
        },
    },
    "& .MuiSwitch-track": {
        backgroundColor: "#ccc",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#000",
    },
}));

export default BlackWhiteSwitch;